import type { MessageActionInvocationStatus } from '@atlassian/conversation-assistant-service-api/types/message-actions';

export type ActionRenderMode = 'IDLE' | 'IN_PROGRESS' | 'ERROR' | 'CANCELLED' | 'COMPLETE';

/** Per-step render state, combining the stored/live invocation status with its apply state. */
export type ActionStepRenderState = {
	storedStatus: MessageActionInvocationStatus;
	currentStatus: MessageActionInvocationStatus | 'idle';
	inProgress: boolean;
	error: Error | undefined;
};

export const getRenderMode = (steps: ActionStepRenderState[]): ActionRenderMode => {
	// IN_PROGRESS
	if (
		steps.some(
			(step) =>
				step.inProgress ||
				step.currentStatus === 'preparing' ||
				step.currentStatus === 'started' ||
				step.currentStatus === 'streaming',
		)
	) {
		return 'IN_PROGRESS';
	}

	// CANCELLED
	// A cleanly dismissed plan: nothing in progress, no errors, and every step was cancelled.
	if (
		steps.length > 0 &&
		steps.every((step) => step.error === undefined) &&
		steps.every((step) => step.storedStatus === 'cancelled' || step.currentStatus === 'cancelled')
	) {
		return 'CANCELLED';
	}

	// ERROR
	if (
		steps.some(
			(step) =>
				step.error !== undefined ||
				step.storedStatus === 'errored' ||
				step.currentStatus === 'errored',
		)
	) {
		return 'ERROR';
	}

	// COMPLETE
	if (
		steps.every((step) => step.storedStatus === 'finished' || step.currentStatus === 'finished')
	) {
		return 'COMPLETE';
	}

	// IDLE: includes the mixed/partial case: some done, some still pending — this is the fix.
	return 'IDLE';
};
